import { injectable } from 'inversify';
import { autorun } from 'mobx';

import { ClientDataStore } from './client-data.store';

@injectable()
export class AnalyticsStore {
    constructor(clientData: ClientDataStore) {
        autorun(() => clientData.portalData && this.setTenant(clientData.portalData.tenant));
    }

    private get ga() {
        return (window as any).ga as UniversalAnalytics.ga;
    }

    private setTenant(tenant: string) {
        this.ga('set', 'dimension1', tenant);
    }

    viewPage(urlAfterRedirects: string) {
        this.ga('set', 'page', urlAfterRedirects);
        this.ga('send', 'pageview');
    }

    viewInvoicePage(invoiceNumber: string, customerId: number) {
        this.viewInvoiceRelatedPage(invoiceNumber, customerId, 'View Invoice Page');
    }

    viewBillingPage(invoiceNumber: string, customerId: number) {
        this.viewInvoiceRelatedPage(invoiceNumber, customerId, 'View Billing Page');
    }

    viewPaymentResultPage(invoiceNumber: string, customerId: number) {
        this.viewInvoiceRelatedPage(invoiceNumber, customerId, 'View Payment Result Page');
    }

    paymentAttemptSuccess(invoiceNumber: string, customerId: number, amount: number) {
        const dimensions = this.getInvoiceDimensions(invoiceNumber, customerId);
        this.ga(
            'send',
            'event',
            'general',
            'Payment Attempt Success',
            'Success',
            amount,
            dimensions
        );
    }

    paymentAttemptFail(
        invoiceNumber: string,
        customerId: number,
        amount: number,
        errorMessage: string
    ) {
        const dimensions = this.getInvoiceDimensions(invoiceNumber, customerId);
        this.ga(
            'send',
            'event',
            'general',
            'Payment Attempt Fail',
            errorMessage,
            amount,
            dimensions
        );
    }

    private getInvoiceDimensions(invoiceNumber: string, customerId: number) {
        return {
            dimension2: customerId,
            dimension3: invoiceNumber,
        };
    }

    private viewInvoiceRelatedPage(invoiceNumber: string, customerId: number, page: string) {
        const dimensions = this.getInvoiceDimensions(invoiceNumber, customerId);
        this.ga('send', 'event', 'general', page, dimensions);
    }
}
